import {CountryState} from "../types";
import {Reducer} from "redux";
import {getCountries } from "../routines";

const countryState: CountryState = {
  countries: [],
};

const country: Reducer<CountryState> = (state: CountryState = countryState, action) => {
  switch (action.type) {
    case getCountries.SUCCESS:
      return {
        ...state,
        countries: action.payload,
      };

    default:
      return state;
  }
};

export default country;
